import { useAuth } from "../../context/contextAuth.js";
import { useDesign } from "../../context/contextDesign.js";
import { useWeb } from "../../context/Dashboard/contextWeb.js";
import { useEffect, useState } from "react";
import RiskExposureListPlaceholder from "../../components/cards/data-card/RiskExposurePlaceholder.jsx";
import RiskExposureList from "../../components/cards/data-card/0-RiskExposureList-Url.jsx";
import Vulnerabilities from "../../components/cards/score-card/0-vulnerabilities.jsx";
import CriticalVul from "../../components/cards/score-card/1-critical-vulnerability.jsx";
import SaveScore from "../../components/cards/score-card/5-save-score.jsx";
import Solutions from "../../components/cards/score-card/4-solutions.jsx";
import PieChartGraph from "./PieChart.jsx";
import "./ScanView.css";

const ScanView = () => {
  const { user } = useAuth();
  const { bHeightVal, zoom } = useDesign();
  const {
    webResults, currentIndex,
    TVulScore, CVulScore, saveScore,
    loadWebData,
    urlVulTable, urlEpssTable,
    scanJob,
    resetState
  } = useWeb();
  const currentResultScanUuid = webResults[currentIndex]?.scan_uuid;
  const scanJobMatchesCurrentResult = Boolean(
    scanJob?.resultScanUuid && scanJob.resultScanUuid === currentResultScanUuid
  );
  const scanIncomplete =
    scanJobMatchesCurrentResult && scanJob?.status === "completed_with_warnings";
  const unavailableTools = scanIncomplete
    ? Object.entries(scanJob?.tools || {})
      .filter(([, value]) => ["failed", "unavailable", "partial"].includes(value?.status))
      .map(([tool]) => tool.toUpperCase())
    : [];
  const props = {
    bHeightVal, urlVulTable, urlEpssTable,
    assets: webResults, saveScore, scanIncomplete
  };
  const [preload, setPreload] = useState(true);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setPreload(false);
    }, 1000);
    return () => clearTimeout(timeout);
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (user) {
          await loadWebData(currentIndex);
        } else {
          resetState();
        }
      } catch (error) {
        console.error('Error in loadWebData:', error);
      }
    };
    fetchData();
  }, [currentIndex]);

  return (
    <div style={{ zoom: zoom }}>
      <div className="bg-success text-light rounded-3 p-1 ps-2 my-2 ms-2 me-2">
        <div>
          Scanned URL: <b>{webResults[currentIndex]?.url || ''}</b>
        </div>
      </div>
      {scanIncomplete && (
        <div className="alert alert-warning mx-2 mb-2 py-2 web-scan-warning" role="alert">
          <strong>Partial scan:</strong>{" "}
          {unavailableTools.length
            ? `${unavailableTools.join(" and ")} could not complete. `
            : "One or more scanners could not complete. "}
          These results do not confirm that the target is vulnerability-free.
        </div>
      )}
      <div className='web-scan-results'>
        {preload? <RiskExposureListPlaceholder /> : <RiskExposureList {...props} /> }
        <div className="web-score-region" style={{ minHeight: bHeightVal }}>
          <div className='web-score-row'>
            <div className='d-flex flex-column web-score-column'>
              <Vulnerabilities score={TVulScore}/>
              <CriticalVul score={CVulScore}/>
            </div>
            <div className='d-flex flex-column web-score-column'>
              <SaveScore setScore={scanIncomplete ? null : saveScore}/>
              <Solutions data={urlVulTable}/>
            </div>
          </div>
          <PieChartGraph />
        </div>
      </div>
    </div>
  );
};

export default ScanView;
